import React, {Fragment} from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

const TabsOnTopFromStatus = (props) => {
  /************ -Tabs START- **************/
  const dataLength = (status) => {
    const filteredObj =
      status.toUpperCase() === "ALL"
        ? props.items
        : props.items.filter((e) => {
            return e.status.toUpperCase() == status.toUpperCase();
          });
    return filteredObj.length;
  };
  const tabsTitle = [
    // ...new Set(props.items.map((e) => e.status)) ---- get unique status object from items
    "Operational",
    "Quarantine",
    "Major Maintenance",
    "Damaged",
    "Discontinued",
  ];
  const handleChangeTabs = (event, newIndex) => {
    // Data is filtered/paginated server-side based on tabIndex (see Cabinets.js fetchData),
    // so we just reset pagination and let that effect refetch the correct page.
    // Filtering `props.items` here (the current page's items) was wrong: it only ever
    // searched the already-loaded page instead of the full result set for the new tab.
    props.setItemsFiltered(null);
    props.setPagingInfo((prev) => ({...prev, page: 0, skip: 0}));
    props.setTabIndex(newIndex);
  };
  /************ -Tabs END- **************/
  return (
    <AppBar position="static" color="default">
      <Tabs
        className="TabsOnTopFromStatus"
        value={props.tabIndex}
        onChange={handleChangeTabs}
        textColor="primary"
        variant="fullWidth"
        aria-label="full width tabs example"
      >
        <Tab
          id="full-width-tab-0"
          aria-controls="full-width-tabpanel-0"
          key="0"
          className="TabsOnTopFromStatus__tab"
          label={
            <Fragment>
              <span>All</span>
              {/* <div className="TabsOnTopFromStatus__tab--number">{dataLength("All")}</div> */}
              <div className="TabsOnTopFromStatus__tab--number">
                {props.countLive && props.countLive.total}
              </div>
            </Fragment>
          }
        />
        {tabsTitle.map((e, i) => (
          <Tab
            id={`full-width-tab-${i + 1}`}
            aria-controls={`full-width-tabpanel-${i + 1}`}
            key={i + 1}
            className="tabs-text-color"
            label={
              <Fragment>
                <span>{e}</span>
                {/* <div className="table-length-cont">{dataLength(e)}</div> */}
                <div className="table-length-cont">
                  {(props.countLive && props.countLive.data && props.countLive.data[e]) || 0}
                </div>
              </Fragment>
            }
          />
        ))}
      </Tabs>
    </AppBar>
  );
};
export default TabsOnTopFromStatus;
